import { useState, useEffect } from 'react';
import { auth } from '../../Backend/firebase/firebase';

function CheckIsEmailVerified() {
    const [isOnline, setIsOnline] = useState(false);

    useEffect(() => {
        var unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
            if (firebaseUser != null) {
                if (firebaseUser.emailVerified) {
                    setIsOnline(true);
                } else {
                    setIsOnline(false);
                }
            }
        });

        return () => unsubscribe();
    });

    return isOnline;
}

export default CheckIsEmailVerified;